import { toast } from 'react-toastify';

export const toastCommingSoon = () => toast.info('Tính năng đang được phát triển', { autoClose: 1000 });
